import { Outlet } from 'react-router-dom';
import { PageTitle } from 'components';
import { useTranslation } from 'react-i18next';

export const Sessions = () => {
  const { t } = useTranslation();
  return (
    <>
      <PageTitle title={t('sessions.metaTitle')} />
      <Outlet />
    </>
  );
};
